export default [
  { to: '/models/all', display: 'Models', contributorsAllowed: true },
  { to: '/models/gens', display: 'Generations', contributorsAllowed: true },
  { to: '/models/genbycountry', display: 'Country model gens', contributorsAllowed: true },
  { to: '/models/miniatures', display: 'Model Miniatures', contributorsAllowed: true },
];
